/**
 * WSAdminCompanyPage - 워크스페이스 회사정보 관리 페이지
 * 
 * 관리자 메뉴에서 별도로 접근 가능한 회사정보 관리 전용 페이지입니다.
 */

import React from 'react';
import { Trans } from '@lingui/macro';
import { Building2 } from 'lucide-react';
import WSCompanyInfoCard from './WSCompanyInfoCard';
import { Workspace } from '../../../models/Workspace';

interface WSAdminCompanyPageProps {
    workspace: Workspace;
    onUpdate?: (silent?: boolean) => void;
}

const WSAdminCompanyPage: React.FC<WSAdminCompanyPageProps> = ({ workspace, onUpdate }) => {
    return (
        <div className="w-full max-w-7xl p-4 md:p-6 lg:p-8 space-y-8 bg-white my-6 mx-4 rounded-panel shadow-sm border">
            {/* 페이지 헤더 */}
            <div className="flex items-center gap-4">
                <div className="p-3 rounded-xl bg-slate-100 border border-slate-200">
                    <Building2 className="h-6 w-6 text-slate-600" />
                </div>
                <div>
                    <h2 className="text-2xl font-bold tracking-tight">
                        <Trans>Company Information</Trans>
                    </h2>
                    <p className="text-sm text-muted-foreground">
                        <Trans>Manage company details for invoices and official communications</Trans>
                    </p>
                </div>
            </div>

            {/* 회사정보 카드 */}
            <WSCompanyInfoCard workspaceId={workspace.id} onUpdate={onUpdate} />
        </div>
    );
};

export default WSAdminCompanyPage;
